module.exports = __webpack_public_path__ + "media/images/icon/icons8-Open in Browser-1f7f9b4ef3873fc7556bb664896c3315.png";